/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ListOrdered = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M10 12h11" }],
    ["path", { d: "M10 18h11" }],
    ["path", { d: "M10 6h11" }],
    ["path", { d: "M4 10h2" }],
    ["path", { d: "M4 6h1v4" }],
    ["path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1" }]
  ]
];

export { ListOrdered as default };
//# sourceMappingURL=list-ordered.js.map
